/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import { Timeslot } from 'types/entities/Timeslot'
import UiOfferTimeslotItem from './UiOfferTimeslotItem'

interface UiOfferTimeslotItemsListProps {
    timeslots: Timeslot[]
    selectedTimeslot: Timeslot | null
    onSelect: (timeslot: Timeslot) => void
}

const UiOfferTimeslotItemsList = (props: UiOfferTimeslotItemsListProps) => {
    if (!props.timeslots.length) {
        return null
    }

    return (
        <>
            {props.timeslots.map((slot, index) => (
                <UiOfferTimeslotItem
                    key={slot.id}
                    index={index}
                    slot={slot}
                    selectedTimeslot={props.selectedTimeslot}
                    onSelect={props.onSelect}
                />
            ))}
        </>
    )
}

export default UiOfferTimeslotItemsList
